export const formatTimeStamp = (timestamp: any) => {
  const a = new Date(timestamp * 1000);
  return a.toLocaleDateString("pt-br", {
    hour: "numeric",
    minute: "numeric",
  });
};
